export enum Level {
  'Poor' = 'Poor',
  'Fair' = 'Fair',
  'Good' = 'Good',
}

export default {};
